import React, { useState, useEffect, useCallback, Fragment, useRef } from "react";
import AccountTab from "../../components/account/AccountTab";
import AccountProfileSection from "../../components/account/AccountProfileSection";
import { useDispatch, useSelector } from "react-redux";
import { LikedTab } from "../../components/account/tabs/LikedTab";
import AccountSidebar from "../../components/account/AccountSidebar";
import { UserlikedVideos, resetLoadingMore } from "../../redux/ApiSlice/LikedVideosSlice";
import AccountTabModal from "../../components/account/AccountTabModal";
import { useOutsideClick } from "../../hooks/useOutsideClick";

export default function Liked() {
    const dispatch = useDispatch();
    const likedVideos = useSelector((state) => state.userLikedPosts);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const [show, setShow] = useState(false);
    const [activeTab, setActiveTab] = useState("");
    const ref = useRef(null);
    const likedScrollRef = useRef(null);

    const handleClickOutside = () => {
        setShow(false);
        setActiveTab("");
    };
    useOutsideClick(ref, handleClickOutside);

    const openDrawer = () => setIsDrawerOpen(true);
    const closeDrawer = () => setIsDrawerOpen(false);

    const { User_likedVideos, loading, loadingMore, nextPage } = likedVideos;

    const fetchData = useCallback(async () => {
        try {
            await dispatch(UserlikedVideos());
        } catch (error) {
          console.error(error);
        }
    }, [dispatch]);

    const handleLikedScroll = useCallback(() => {
        const container = likedScrollRef.current;
        if (!container || !nextPage || loadingMore) {
            return;
        }

        const hasReachedBottom =
            container.scrollTop + container.clientHeight >= container.scrollHeight - 10;

        if (hasReachedBottom) {
            dispatch(
                UserlikedVideos({
                    nextUrl: nextPage,
                    isLoadMore: true,
                })
            );
        }
    }, [dispatch, loadingMore, nextPage]);

    useEffect(() => {

        window.scrollTo({ top: 0, behavior: 'smooth' });

        dispatch(resetLoadingMore());
        fetchData();
    }, [fetchData, dispatch]);

    useEffect(() => {
        const container = likedScrollRef.current;
        if (!container) return;

        container.addEventListener("scroll", handleLikedScroll);

        return () => {
            container.removeEventListener("scroll", handleLikedScroll);
        };
    }, [handleLikedScroll]);

    return (
        <Fragment>
            <div
                ref={likedScrollRef}
                className={`bg-[#fff] dark:bg-[#1E1D21] overflow-hidden h-full relative ${isDrawerOpen ? "" : "overflow-y-scroll"}`}
            >
                <AccountProfileSection
                    handleOpenSideBar={openDrawer}
                    handleCloseSideBar={closeDrawer}
                    isDrawerOpen={isDrawerOpen}
                    setActiveTab={setActiveTab}
                    setShow={setShow}
                    show={show}
                />
                <div className="sticky top-0 z-30">
                    <AccountTab activeTab={"Liked"} />
                </div>
                <div className="w-full h-fit">
                    <LikedTab
                        loading={loading}
                        User_likedVideos={User_likedVideos}
                        nextPage={nextPage}
                    />
                    {loadingMore && (
                        <div className="flex justify-center items-center py-4">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 dark:border-white"></div>
                        </div>
                    )}
                </div>
                <div className="grid grid-cols-12 overflow-hidden">
                    <div className="col-span-12">
                        <AccountSidebar
                            isDrawerOpen={isDrawerOpen}
                            setIsDrawerOpen={setIsDrawerOpen}
                            openDrawer={openDrawer}
                            closeDrawer={closeDrawer}
                        />
                    </div>
                </div>
            </div>

            {show && (
                <div className={"absolute h-full w-full top-0 overflow-hidden"}>
                    <div
                        className="absolute h-screen w-full top-0 opacity-100 bg-opacity-70 bg-black z-50"
                        onClick={handleClickOutside}
                    />
                    <div
                        ref={ref}
                        className="absolute top-0 left-4 z-50 w-[90%] h-[-webkit-fill-available] mt-4 mb-3 flex justify-center rounded-lg  bg-black duration-1000 transform opacity-100"
                    >
                        <AccountTabModal
                            ref={ref}
                            // data={data}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                        />
                    </div>
                </div>
            )}
        </Fragment>
    );
}
